import { createContext, useContext } from 'react';

const BootstrapAuthContext = createContext({
  authError: null,
  sessionNotice: null,
  reportExpiredSession: () => {},
});

export function useBootstrapAuth() {
  return useContext(BootstrapAuthContext);
}

export default BootstrapAuthContext;
